export default __webpack_public_path__ + "static/olx-01e2ba4a15142529b37c2cc1dd99e7be.png";